import { connect } from 'react-redux';
import DateFilter from 'ha/components/Filters/DateFilter/DateFilter';
import { isMobileDatePickerOpen } from 'ha/pages/Search/selectors';
import {
  loadPreviewNumberOfListings,
  clearPreviewNumberOfListings,
  onChangeFilters,
  toggleMobileDatePicker,
  toggleFilterPopover,
} from '../../actions';

import { getSearchParams, getDateFilter } from '../../selectors';

export default connect(
  state => ({
    searchParams: getSearchParams(state),
    isOpen: isMobileDatePickerOpen(state),
    dateFilter: getDateFilter(state),
  }),
  {
    onChangeFilters,
    onToggle: toggleMobileDatePicker,
    loadPreviewNumberOfListings,
    clearPreviewNumberOfListings,
    toggleFilterPopover,
  },
)(DateFilter);
